import { Languages } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { LOCALES, type Locale } from '@/lib/i18n';
import { Button } from '@/components/ui/button';

/** §25 — one switch flips strings, `dir` and the font, everywhere at once. */
export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const next: Locale = i18n.language.startsWith('ar') ? 'en' : 'ar';

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => void i18n.changeLanguage(next)}
      title={LOCALES[next].nativeName}
    >
      <Languages className="h-4 w-4" />
      <span>{LOCALES[next].nativeName}</span>
    </Button>
  );
}
